import { HistoryTabContainer } from '../../historyTab/HistoryTabContainer';

/** Route element for Historia (/main/dod/history). */
export const HistoryRoute = (): JSX.Element => <HistoryTabContainer />;
